export default "<app-navbar selectedIndex=2>\n</app-navbar>\n<app-main-template [navItems]='navItems' title='NOS ACTIONS'></app-main-template>\n"